var map = {
	"./88Casino/BG.jpg": 9813,
	"./88Casino/BG_phone.jpg": 7446,
	"./88Casino/LOGO.png": 6445,
	"./BG.jpg": 4289,
	"./BG2.jpg": 5405,
	"./BG3.jpg": 4178,
	"./DW/BG.jpg": 4323,
	"./DW/BG_old.png": 5185,
	"./DW/BG_phone.png": 6751,
	"./DW/LOGO.svg": 9292,
	"./FlagC/CN.svg": 751,
	"./FlagC/HK.svg": 4885,
	"./FlagC/ID.svg": 2996,
	"./FlagC/IN.svg": 3210,
	"./FlagC/JP.svg": 6747,
	"./FlagC/KH.svg": 7036,
	"./FlagC/KR.svg": 2727,
	"./FlagC/MY.svg": 7969,
	"./FlagC/PH.svg": 1022,
	"./FlagC/TH.svg": 8032,
	"./FlagC/TW.svg": 6432,
	"./FlagC/US.svg": 926,
	"./FlagC/VN.svg": 7396,
	"./Frame.svg": 7381,
	"./HYDLOGO.svg": 8610,
	"./LOGO.svg": 4870,
	"./LeliGameLoginBG.png": 1602,
	"./LeliGameLoginBG_phone.png": 7790,
	"./Lelly/BG.png": 6211,
	"./Lelly/BG_phone.png": 5883,
	"./Lelly/logo/1.svg": 1392,
	"./Lelly/logo/2.svg": 335,
	"./Lelly/logo/3.svg": 3449,
	"./Lelly/logo/4.svg": 3080,
	"./Lelly/logo/5.svg": 250,
	"./Lelly/logo/Crown.svg": 3027,
	"./Login.svg": 9852,
	"./RioliveGameLoginBG.png": 6053,
	"./RioliveGameLoginBG_phone.png": 9701,
	"./RioliveLOGO.svg": 156,
	"./UN/BG.png": 7061,
	"./UN/BG_phone.png": 6819,
	"./UN/LOGO.svg": 1826,
	"./US.svg": 736,
	"./account.svg": 5067,
	"./c101GameLoginBG.jpg": 5219,
	"./c101GameLoginBG_phone.jpg": 6689,
	"./c101LOGO.svg": 7155,
	"./cn.png": 4068,
	"./cn.svg": 4640,
	"./computer.svg": 4850,
	"./dollar.svg": 601,
	"./edit.png": 8518,
	"./exchange.png": 8901,
	"./hide.svg": 2146,
	"./hk.svg": 4264,
	"./indo.svg": 1579,
	"./jp.svg": 562,
	"./key.png": 7986,
	"./key.svg": 5582,
	"./korea.svg": 9609,
	"./layer.svg": 9932,
	"./list.svg": 7468,
	"./lists.svg": 2279,
	"./malaysia.svg": 130,
	"./onslive/BG.jpg": 6216,
	"./onslive/BG_phone.jpg": 6930,
	"./onslive/LOGO.svg": 2562,
	"./redlantern/BG.png": 8017,
	"./redlantern/LOGO.png": 8688,
	"./redlantern/LOGO.svg": 3412,
	"./role.svg": 707,
	"./ru.svg": 8585,
	"./share.png": 7317,
	"./show.svg": 1744,
	"./spain.svg": 9812,
	"./thai.svg": 7934,
	"./transfer.png": 9741,
	"./uk.svg": 1671,
	"./unLOGO.png": 5961,
	"./vietnam.svg": 995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;